import { render, staticRenderFns } from "./CourierMenuDetail.vue?vue&type=template&id=3690c858&"
import script from "./CourierMenuDetail.vue?vue&type=script&lang=js&"
export * from "./CourierMenuDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports